import React from "react";

import Drawer from "@mui/material/Drawer";

import { useStoreSelector } from "../../../store/Hooks";

import CommunicationSetEditor from "../../communications/CommunicationSetEditor";
import ConditionsEditor from "../../conditions/ConditionsEditor";
import IntervalsEditor from "../../communications/IntervalsEditor";
import InteractionNodeIntervalsEditor from "../../communications/InteractionNodeIntervalsEditor";
import InteractionEditor from "../../interactions/InteractionEditor";
import IntervalSetEditor from "../../communications/IntervalSetEditor";
import AnchorForm from "../../patients/AnchorEditor";
import CommitTool from "../../commit/CommitTool";
import { RightDrawerData } from "../../../store/slices/NavSlice";
import { DatabaseTable } from "../../../models/BaseTable";
import InteractionSchedule from "../../patients/InteractionSchedule";
import TestTools from "../../test/TestTools";

export default function RightDrawer() {
  const rightDrawerData = useStoreSelector(
    (state) => state.nav.rightDrawerData,
  );
  const rightDrawerOpen = useStoreSelector(
    (state) => state.nav.rightDrawerOpen,
  );
  const currentParent = useStoreSelector((state) => state.nav.currentParent);
  const intervalID = useStoreSelector((state) => state.nav.intervalID);
  // Make a drawer for each entry in rightDrawerData
  // Each entry has it's own type, which determines the component rendered
  const drawerList: React.ReactElement[] = [];
  rightDrawerData.forEach((data: RightDrawerData, index: number) => {
    if (
      data.type === "communications" &&
      typeof data.resourceID !== "undefined" &&
      typeof data.resourceName !== "undefined"
    ) {
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <CommunicationSetEditor
            resourceID={data.resourceID}
            resourceName={data.resourceName}
            communicationSetID={data.content}
            intervalID={intervalID}
            currentParent={currentParent}
            inDrawer={true}
            intervalSetEditMode={data.extraData.editMode}
          />
        </Drawer>,
      );
    } else if (data.type === "conditions") {
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <ConditionsEditor
            conditions={data.content.conditions}
            title={data.content.title}
            outerTable={data.resource}
            outerTableID={data.resourceID}
            setID={data.extraData.setID}
            inDrawer={true}
          />
        </Drawer>,
      );
    } else if (data.type === "interaction_schedule") {
      console.log(data.content)
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <InteractionSchedule anchorID={data.content.id} subjectID = {data.content.subject_id} targetID = {data.content.target_id} />
        </Drawer>,
      );
    } else if (data.type === "interactions") {
      let tempInteractionNode = null;
      let associatedIntervals = null;
      if (data.extraData) {
        if (typeof data.extraData.interactionNode !== "undefined") {
          tempInteractionNode = data.extraData.interactionNode;
        }
        if (typeof data.extraData.associatedIntervals !== "undefined") {
          associatedIntervals = data.extraData.associatedIntervals;
        }
      }
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <InteractionEditor
            interaction={data.content}
            inDrawer={true}
            interactionNode={tempInteractionNode}
            associatedIntervals={associatedIntervals}
          />
        </Drawer>,
      );
    } else if (data.type === "interactionNodeIntervals") {
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <InteractionNodeIntervalsEditor
            interaction_node_interval={data.content}
            inDrawer={true}
          />
        </Drawer>,
      );
    } else if (data.type === "intervals") {
      let parent = null;
      let interactionParentInterval = null;
      let intervalSet = null;
      let intervalSetEditMode = null;
      let newInterval = false;
      if (data.extraData) {
        if (typeof data.extraData.parent !== "undefined") {
          parent = data.extraData.parent;
        }
        if (typeof data.extraData.interactionParentInterval !== "undefined") {
          interactionParentInterval = data.extraData.interactionParentInterval;
        }
        if (typeof data.extraData.intervalSet !== "undefined") {
          intervalSet = data.extraData.intervalSet;
        }
        if (typeof data.extraData.intervalSetEditMode !== "undefined") {
          intervalSetEditMode = data.extraData.intervalSetEditMode;
        }
        if (typeof data.extraData.new !== "undefined") {
          newInterval = data.extraData.new;
        }
      }

      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <IntervalsEditor
            interval={data.content}
            inDrawer={true}
            interactionParentInterval={interactionParentInterval}
            intervalSet={intervalSet}
            intervalSetEditMode={intervalSetEditMode}
            parent={parent}
            new={newInterval}
          />
        </Drawer>,
      );
    } else if (data.type === "intervalSets") {
      let interaction = null;
      if (data.extraData) {
        if (typeof data.extraData.interaction !== "undefined") {
          interaction = data.extraData.interaction;
        }
      }
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <IntervalSetEditor interval_set={data.content} inDrawer={true} interaction={interaction}/>
        </Drawer>,
      );
    } else if (data.type === "commit") {
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <CommitTool commitData={data.content} />
        </Drawer>,
      );
    } else if (data.type === "anchor" && typeof data.resourceID === "number") {
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <AnchorForm anchor_id={data.resourceID} />
        </Drawer>,
      );
    } else if (data.type === "testing" ) {
      drawerList.push(
        <Drawer key={index} open={rightDrawerOpen} anchor="right">
          <TestTools />
        </Drawer>,
      );
    }
  });

  return <React.Fragment key="right">{drawerList}</React.Fragment>;
}
